import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Typography, Box, Switch } from '@mui/material';
import { SCUIButton } from '../../../../atomic/atoms';

import ScheduleGroupCommand from '../../../../services/command/scheduleGroupCommand/ScheduleGroupCommand.services';
import { AGD } from './addGroupDialog.classes';

export const AddGroupDialog = ({ open, getGroups, onClose, selectedGroup = null, setIsLoading }: any) => {
    const [groupName, setGroupName] = useState<string>('');
    const [isActive, setIsActive] = useState<boolean>(false);

    const { t } = useTranslation();

    const handleClose = () => {
        setIsActive(false);
        setGroupName('');
        onClose();
    };

    const handleAddEditGroup = () => {
        if (groupName) {
            setIsLoading(true);
            if (selectedGroup) {
                ScheduleGroupCommand.UpdateGroup({
                    groupName,
                    isActive,
                    groupId: selectedGroup?.groupId,
                })
                    .then((res: any) => {
                        if (res) {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: t('general.success'),
                                showConfirmButton: false,
                                timer: 1500,
                            });
                            handleClose();
                            getGroups();
                        }
                        setIsActive(false);
                        setGroupName('');
                    })
                    .catch(() => {
                        Swal.fire(t('general.anErrorOccured'), '', 'error');
                        setIsLoading(false);
                    });
                return;
            }
            ScheduleGroupCommand.CreateGroup({
                groupName,
                isActive,
            })
                .then((res: any) => {
                    if (res) {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: t('general.success'),
                            showConfirmButton: false,
                            timer: 1500,
                        });
                        setIsLoading(false);
                        getGroups();
                        handleClose();
                    }
                })
                .catch(() => {
                    Swal.fire(t('general.anErrorOccured'), '', 'error');
                    setIsLoading(false);
                });
        } else {
            Swal.fire(t('scheduleGroup.missingGroupName'), '', 'error');
        }
    };

    useEffect(() => {
        if (selectedGroup) {
            setGroupName(selectedGroup?.groupName || '');
            setIsActive(selectedGroup?.isActive || false);
        }
    }, [selectedGroup]);

    return (
        <Dialog className={AGD.dialog} open={open} onClose={handleClose}>
            <DialogTitle className={AGD.title}>
                {selectedGroup ? t('scheduleGroup.updateGroup') : t('scheduleGroup.createGroup')}
            </DialogTitle>
            <DialogContent className={AGD.content} sx={{ width: '400px', padding: '24px !important' }}>
                <TextField
                    margin="dense"
                    label={t('scheduleGroup.groupName')}
                    type="text"
                    fullWidth
                    placeholder={t('scheduleGroup.enterGroupName')}
                    slotProps={{ inputLabel: { shrink: true } }}
                    variant="standard"
                    className={AGD.groupNameInput}
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                />
                <Box className={AGD.activeRow} sx={{ display: 'flex', flexDirection: 'row', marginTop: '16px', alignItems: 'center' }}>
                    <Typography className={AGD.activeLabel} sx={{ fontSize: '18px', fontWeight: 'bold', marginRight: '16px' }}>
                        {t('scheduleGroup.isActive')}:
                    </Typography>
                    <Switch
                        className={AGD.activeSwitch}
                        checked={isActive}
                        onChange={(e) => {
                            setIsActive(e.target.checked);
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions className={AGD.actions}>
                <SCUIButton
                    className={AGD.submitButton}
                    style={{ marginRight: '8px' }}
                    size="s"
                    type="primary"
                    sizeType="default"
                    text={selectedGroup ? t('general.update') : t('general.add')}
                    onClick={handleAddEditGroup}
                />
                <SCUIButton
                    className={AGD.cancelButton}
                    type="primary"
                    sizeType="default"
                    size="s"
                    text={t('general.cancel')}
                    onClick={handleClose}
                />
            </DialogActions>
        </Dialog>
    );
};
